var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isSnackbar)?_c('snackbar',{attrs:{"message":_vm.message,"backgroundColor":_vm.backgroundColor}}):_vm._e(),_c('Init',{staticClass:"body-min-width"}),_c('ScrollToTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }